import { useState, useMemo, useCallback, useEffect, useRef } from "react"
import { Grid3X3, List } from "lucide-react"
import { Button, Form, Modal, ButtonGroup, Badge, Card, Row, Col } from "react-bootstrap"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PageHeader from "../components/PageHeader"
import { LMSBASEURL } from "../config/apiUrls"
import { debounce } from "../utils/debounce"
import { isMobile } from "react-device-detect"
import Swal from "sweetalert2"
import { DisabledMessage, excludedStatuses, getStatusBadgeVariant, isDisabled, statusButtons, statusOptions } from "../utils/utils"
import ApplicationTimelinePopup from "./AppoicationHistoryPopup"
import StatusChangeModal from "../components/StatusChangeMOdal"
import { useSearchParams } from 'react-router-dom';
import StudentApplicationFilters from "../components/student-application-filter"
import { Funnel } from "lucide-react"
import StudentApplicationGrid from "../components/Student Job/student-application/student-applicationgrid"
import StudentApplicationTable from "../components/Student Job/student-application/student-applicationlist"
import { PaginationControls } from "../components/PaginationControls";

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #ced4da",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #ced4da",
    },
    minHeight: "38px",
    fontSize: "14px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#6c757d",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#495057",
  }),
}

const studying_year = ["1st Year","2nd Year", "3rd Year","4th Year"];

const makeOptions = (arr) => arr.map((item) => ({ value: item, label: item }));

export default function StudentApplicationList() {
    const [searchParams, setSearchParams] = useSearchParams();
    const selectAllRef = useRef(null);
    const [students, setStudents] = useState([])
    const [selectedStudents, setSelectedStudents] = useState(new Set())
    const [viewMode, setViewMode] = useState("grid")
    const [currentPage, setCurrentPage] = useState(1)
    const [studentsPerPage] = useState(9)
    const [showInterviewModal, setShowInterviewModal] = useState(false)
    const [showHistoryModal, setShowHistoryModal] = useState(null)
    const [selectedCity, setSelectedCity] = useState(null);
    const [inputText, setInputText] = useState('');
    const [skillsData,setSkillsData] = useState([]);
    const [selectedSkills,setSelectedSkills] = useState([])
    const [selectedJobTitle,setSelectedJobTitle] = useState(null)
    const [jobTitles, setJobTitles] = useState([]);
    const [loadingStudentData,setLoadingStudent] = useState(false)
    const [organizationId, setOrganizationId] = useState(null);
    const [filtersInitialized, setFiltersInitialized] = useState(false); // New state to track filter initialization
    const instituteId = sessionStorage.getItem("instituteId");
    const updatedBy = sessionStorage.getItem("id")
    const token = process.env.REACT_APP_API_TOKEN;
    const [jobStatus,setJobStatus] = useState(null)
    const [employmentType,setEmploymentType] = useState(null)
    const [interviewData, setInterviewData] = useState({
        studentId: null,
        date: new Date(),
        time: "",
        message: "",
    })
    const [showModal, setShowModal] = useState(false);
    const [showHireModal, setShowHireModal] = useState(false);
    const [hiredModalDetails,setHiredModalDetails] = useState({})
    const [modalStatus, setModalStatus] = useState("");
    const [modalStudentId, setModalStudentId] = useState(null);
    const InstituteId = sessionStorage.getItem("instituteId");
    const [selectedEducationYear, setSelectedEducationYear] = useState([]);
    const [selectedStudyingYear, setSelectedStudyingYear] = useState([]);
    const [selectedDegreeTitle, setSelectedDegreeTitle] = useState([]);
    const [activeTab, setActiveTab] = useState("all_application");
    const [placements, setPlacements] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState(null);
    const [filters, setFilters] = useState({
        offer_letter_acceptance: "",
        search: "",
        per_page: 20,
        page: 1,
    });
    const [isNowAndLater,setIsNowAndLater] = useState(false)
    const [filterValues, setFilterValues] = useState([]);
    const [appliedFilterValues, setAppliedFilterValues] = useState(null);

    const fetchPlacements = (newFilters = {}) =>{
        setLoading(true)
        const query = { ...filters, ...newFilters };

        Object.keys(query).forEach((key) => {
            const value = query[key];
            if (value === undefined || value === null || value === "") {
                delete query[key];
            }
        });

        if (!query.offer_letter_acceptance) {
            delete query.offer_letter_acceptance;
        }
        
        const params = new URLSearchParams(query);
        
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Accept", "application/json");

        fetch(`${LMSBASEURL}/api/placements?${params.toString()}`, {
            method: "GET",
            headers: myHeaders,
        })
        .then((response) => response.json())
        .then((result) => {
            setPlacements(result.data || []);
            setPagination({
                current_page: result.current_page,
                last_page: result.last_page,
                total: result.total,
            });
            setLoading(false);
        })
        .catch((error) => {
            console.error(error);
        }).finally(()=>{
            setLoading(false);
        });
    }

    useEffect(() => {
        if(activeTab!="all_application"){
            fetchPlacements();
        }
    }, [activeTab]);

    const handleSearch = useCallback(
        debounce((value) => {
            fetchPlacements({ search: value, page: 1 });
            setFilters((prev) => ({ ...prev, search: value, page: 1 }));
        }, 500),
        []
    );

    const handleFilterChange = (e) => {
        const value = e.target.value;
        setFilters((prev) => ({
            ...prev,
            offer_letter_acceptance: value,
            page: 1,
        }));
        fetchPlacements({ offer_letter_acceptance: value, page: 1 });
    };

    const handleInputChange = (inputValue, setSelected, currentOptions, validator) => {
        if (inputValue.includes(",")) {
            const values = inputValue
                .split(",")
                .map((v) => v.trim())
                .filter((v) => v.length > 0);

            const validOptions = values
                .filter((v) => !validator || validator(v))
                .map((v) => ({ value: v, label: v }));

            const uniqueOptions = validOptions.filter(
                (opt) => !currentOptions.some((c) => c.value === opt.value)
            );

            setSelected([...currentOptions, ...uniqueOptions]);
        }
    };

    // Status options for reuse
    const employmentTypeOption = [
        {value:"job", label:"Job"},
        {value:"internship", label:"Internship"}
    ];

    // Initialize filters from URL parameters
    useEffect(() => {
        const orgId = searchParams.get('org_id');
        const status = searchParams.get('status');
        const employmentTitle = searchParams.get('employment_title');
        
        if (orgId) {
            setOrganizationId(orgId);
        }
        
        if (status) {
            const statusOption = statusOptions.find(option => option.value === status);
            if (statusOption) {
                setJobStatus(statusOption);
            }
        }
        
        if (employmentTitle) {
            // Set the employment title as selected job title
            const jobTitleOption = {
                value: employmentTitle,
                label: employmentTitle
            };
            setSelectedJobTitle(jobTitleOption);
            
            // Also add it to jobTitles array if it's not already there
            setJobTitles(prevTitles => {
                const exists = prevTitles.some(title => title.value === employmentTitle);
                if (!exists) {
                    return [...prevTitles, jobTitleOption];
                }
                return prevTitles;
            });
        }
        
        // Mark filters as initialized
        setFiltersInitialized(true);
    }, [searchParams]);

    const loadCityOptions = useCallback(async (inputValue, callback) => {
        if (inputValue.length < 3) {
            callback([]);
            return;
        }

        try {
            const response = await fetch(`${LMSBASEURL}/api/search-city?searchTerm=${inputValue}`, {
            headers: {
                "Authorization": token,
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to search cities");

            const options = result?.data?.map(({ id, name }) => ({
            label: name,
            value: id,
            })) || [];

            callback(options);
        } catch (error) {
            console.error("City Search Error:", error.message);
            callback([]);
        }
    }, [token]);

    const debouncedLoadCityOptions = useMemo(() => debounce(loadCityOptions, 500), [loadCityOptions]);

    const normalizeApplications = (applications) => {
        return applications.map((app) => {
            const student = app.student;
            const emp =app.employment;
            const org= app.organisation;
            const details = student.student_details;
            return {
                id: app.id,
                student_id:app.student_id,
                name: `${student.first_name} ${student.last_name}`,
                email: student.email,
                phone: student.contact_number,
                status: app.status || "pending",
                college: details?.institution_name || "-",
                company: student?.company || null,
                location: details?.city?.name || "N/A",
                gpa: details?.gpa || "-",
                isExperience: details?.total_experience > 0 ? "yes" : "no",
                experience: details?.total_experience || 0,
                position: app.employment?.employment_title || "-",
                skills: student?.student_skills?.map((s) => s.skill.skill_title) || [],
                degreeTitle:app?.degree_title || "",
                appliedDate: app.created_at || new Date().toISOString(),
                emp:emp,
                org:org,
                details:details,
                eduArr:student?.educations || []
            };
        });
    };

    const fetchStudentsApplication = useCallback(async () => {
        if (!filtersInitialized) return;
        setLoadingStudent(true);

        try {
            const url = `${LMSBASEURL}/api/employment/get-application`;
            const sanitizedEducationMarksFilters = appliedFilterValues?.filter(
                item => item?.degree !== null
            );


            const body = {
                institute_id: instituteId,
                status: jobStatus?.value || undefined,
                skills: selectedSkills?.length
                    ? selectedSkills.map(sk => sk.value)
                    : undefined,
                city_id: selectedCity?.value || undefined,
                employment_title: selectedJobTitle?.value || undefined,
                org_id: organizationId || undefined,
                education_year: selectedEducationYear?.length
                    ? selectedEducationYear.map(item => item.value)
                    : undefined,
                studying_year: selectedStudyingYear?.length
                    ? selectedStudyingYear.map(item => item.value)
                    : undefined,
                degree_title: selectedDegreeTitle?.length
                    ? selectedDegreeTitle.map(item => item.value)
                    : undefined,
                employment_type: employmentType?.value || undefined,
                ...(sanitizedEducationMarksFilters?.length > 0 && {
                    education_marks_filters: sanitizedEducationMarksFilters
                }),
            };

            // Remove undefined keys (optional but clean)
            Object.keys(body).forEach(
                key => body[key] === undefined && delete body[key]
            );

            const APItoken = process.env.REACT_APP_API_TOKEN;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: APItoken,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(body),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || "Failed to load Student Application");
            }

            const normalized = normalizeApplications(result?.data || []);
            setStudents(normalized);
        } catch (error) {
            setStudents([]);
            console.error("Student Application Error:", error.message);
        } finally {
            setLoadingStudent(false);
        }
    }, [instituteId, selectedSkills, selectedCity, selectedJobTitle, jobStatus, organizationId, filtersInitialized,selectedEducationYear,selectedStudyingYear,selectedDegreeTitle,employmentType,appliedFilterValues ]);


    const fetchSkills = useCallback(async () => {
        try {
            let url = `${LMSBASEURL}/api/skill`;
            const APItoken = process.env.REACT_APP_API_TOKEN;

            const response = await fetch(url, {
            headers: {
                Authorization: APItoken,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to load skills");
            const options = result?.data?.map(({ id, skill_title }) => ({
                label: skill_title,
                value: id,
            })) || [];
            setSkillsData(options)
        } catch (error) {
            setSkillsData([])
            console.error("Student Fetch Error:", error.message);
        }
    }, []);

    const fetchJobTitle = useCallback(async (skill) => {
        const raw = JSON.stringify({
            "institute_id": InstituteId,
            // "skills": skill,
        });
        try {
            let url = `${LMSBASEURL}/api/getjobtitle`;
            const APItoken = process.env.REACT_APP_API_TOKEN;

            const response = await fetch(url, {
                headers: {
                    Authorization: APItoken,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                method: "POST",
                body: raw,
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to load job titles");

            const seen = new Set();
            const uniqueJobs = result?.data.filter((job) => {
                const lower = job.toLowerCase();
                if (seen.has(lower)) return false;
                seen.add(lower);
                return true;
            });
            const formatted = uniqueJobs.map((job) => ({
                value: job,
                label: job,
            }));

            setJobTitles(formatted); 
        } catch (error) {
            setJobTitles([]);
            console.error("Job Title Fetch Error:", error.message);
        }
    }, [InstituteId]);

    // Reset filters function
    const resetFilters = useCallback(() => {
        setJobStatus(null);
        setSelectedSkills([]);
        setSelectedJobTitle(null);
        setSelectedCity(null);
        setOrganizationId(null);
        
        // Remove URL parameters
        setSearchParams({});
    }, [setSearchParams]);

    // Fetch skills on component mount
    useEffect(()=>{
        fetchSkills()
    },[fetchSkills])

    // Fetch students when filters change or are initialized
    useEffect(() => {
        fetchStudentsApplication();
        fetchJobTitle()
    }, [fetchStudentsApplication]);

    const handleSelectSkills = async (selectedOptions) => {
        const values = selectedOptions ? selectedOptions.map(opt => opt?.value) : [];
        setSelectedSkills(selectedOptions || []);
        // await fetchJobTitle(values);
    };

    const updateStatus = async (studentId, newStatus, com) => {
        const role = sessionStorage.getItem('role')
        if(role == 'Institute' || role =='Organisation'){
            try {
                const myHeaders = {
                    "Authorization": token,
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                };
    
                const raw = JSON.stringify({
                    id: [studentId],
                    status: newStatus,
                    comment: com,
                    updated_by: Number(updatedBy),
                    role: role
                });
    
                const response = await fetch(`${LMSBASEURL}/api/employment/application-status`,{
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                });
    
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
    
                setStudents((prev) => prev.map((student) =>student.id === studentId? { ...student, status: newStatus } : student));
                const result = await Swal.fire({
                    icon: 'success',
                    title: '',
                    text: "Status updated successfully",
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#dc3545'
                });
                if (result.isConfirmed) {
                    if(newStatus=="hired"){
                        confirmStatusToHired(studentId, newStatus)
                    }else{
                        setModalStudentId(null);
                        setModalStatus('');
                        setShowModal(false);
                        setHiredModalDetails({})
                    }
                }
            } catch (error) {
                console.error("API call failed:", error);
            }
        }
    };

    const confirmStatusChange = (studentId, newStatus,student) => {
        setModalStudentId(studentId);
        setModalStatus(newStatus);
        setShowModal(true);
        setHiredModalDetails(student)
    };

    const confirmStatusToHired=async(studentId, newStatus,stdDetails)=>{
        const result = await Swal.fire({
            title: 'Do you want to send the Offer Letter?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Now',
            cancelButtonText: 'Later',
            customClass: {
                popup: 'swal2-popup-custom',
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-secondary'
            }
        });

        if (result.isConfirmed) {
            setModalStudentId(studentId);
            setModalStatus(newStatus);
            setShowModal(true);
            setShowHireModal(true);
            setIsNowAndLater(true)
            if(stdDetails){
                setHiredModalDetails(stdDetails)
            }
        }
    }

    const handleConfirm = (studentId, status, finalComment) => {
        updateStatus(studentId, status, finalComment);
        
        // If all selected students are processed, reset filters
        if (Array.isArray(studentId) && studentId.length === selectedStudents.size) {
            resetFilters();
        }
    };

    const bulkUpdateStatus = async(status) => {
        const selectedIds = Array.from(selectedStudents)
        setModalStudentId(selectedIds);
        setModalStatus(status);
        setShowModal(true);       
    }

    const scheduleInterview = () => {
        if (!interviewData.date || !interviewData.time || !interviewData.studentId) return
        setInterviewData({
            studentId: null,
            date: "",
            time: "",
            message: "",
        })
        setShowInterviewModal(false)
    }

    const openHistoryModal =async (student) => {
        setShowHistoryModal(student)
    }

    const toggleStudentSelection = (studentId) => {
        const newSelected = new Set(selectedStudents)
        if (newSelected.has(studentId)) {
            newSelected.delete(studentId)
        } else {
            newSelected.add(studentId)
        }
        setSelectedStudents(newSelected)
    }

    const selectAllStudents = () => {
        const eligibleIds = students
            .filter(student => !excludedStatuses.includes(student.status))
            .map(student => student.id);

        if (selectedStudents.size === eligibleIds.length) {
            setSelectedStudents(new Set());
        } else {
            setSelectedStudents(new Set(eligibleIds));
        }
        
        // Reset filters after select all action
        setTimeout(() => {
            resetFilters();
        }, 100);
    };

    useEffect(() => {
    const eligibleIds = students
        .filter((s) => s.status !== "hired" && s.status !== "accept" && s.status !== "rejected" && s.status !== "cancelled")
        .map((s) => s.id);

    if (selectAllRef.current) {
        selectAllRef.current.indeterminate =
        selectedStudents.size > 0 && selectedStudents.size < eligibleIds.length;
    }
    }, [selectedStudents.size, students]);

    const headerTbl ={
        whiteSpace: "nowrap",
        textOverflow: "ellipsis", 
        overflow:"hidden"
    }

    const handlePercentageFilterChange = (filters) => {
        setFilterValues(filters);

    };

    const handleApplyPercentageFilters = (filters) => {
        setAppliedFilterValues(filters);
    };

    return (
        <>
            <PageHeader title="Student Applications"
                breadcrumbs={[
                    { label: "Dashboard", path: "/institute-dashboard" },
                    { label: "Student Applications", active: true }
            ]}
            />

            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <button
                    className={`nav-link ${activeTab === "all_application" ? "active" : ""}`}
                    onClick={() => setActiveTab("all_application")}
                    >
                    All Application
                    </button>
                </li>
                <li className="nav-item">
                    <button
                    className={`nav-link ${activeTab === "hired" ? "active" : ""}`}
                    onClick={() => setActiveTab("hired")}
                    >
                    Placement Offer Status
                    </button>
                </li>
            </ul>
            {activeTab =='all_application' ? 
            <main>
                <StudentApplicationFilters
                    statusOptions={statusOptions}
                    setSelectedSkills={setSelectedSkills}
                    jobStatus={jobStatus}
                    setJobStatus={setJobStatus}
                    skillsData={skillsData}
                    selectedSkills={selectedSkills}
                    handleSelectSkills={handleSelectSkills}
                    jobTitles={jobTitles}
                    selectedJobTitle={selectedJobTitle}
                    setSelectedJobTitle={setSelectedJobTitle}
                    debouncedLoadCityOptions={debouncedLoadCityOptions}
                    inputText={inputText}
                    setInputText={setInputText}
                    selectedCity={selectedCity}
                    setSelectedCity={setSelectedCity}
                    selectedEducationYear={selectedEducationYear}
                    setSelectedEducationYear={setSelectedEducationYear}
                    studying_year={studying_year}
                    selectedStudyingYear={selectedStudyingYear}
                    setSelectedStudyingYear={setSelectedStudyingYear}
                    selectedDegreeTitle={selectedDegreeTitle}
                    setSelectedDegreeTitle={setSelectedDegreeTitle}
                    employmentTypeOption={employmentTypeOption}
                    employmentType={employmentType}
                    setEmploymentType={setEmploymentType}
                    organizationId={organizationId}
                    setOrganizationId={setOrganizationId}
                    resetFilters={resetFilters}
                    customSelectStyles={customSelectStyles}
                    handleInputChange={handleInputChange}
                    makeOptions={makeOptions}
                    handleFilterChange={handlePercentageFilterChange}
                    handleApply={handleApplyPercentageFilters}
                />
                {loadingStudentData ? 
                    <div className="py-4">
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        </div>
                    </div>
                :
                    <>
                        <div className={students?.length !== 0 ? "d-flex justify-content-between align-items-center mb-4": "d-flex justify-content-end align-items-center mb-4"}>
                            {students?.length !== 0 && (
                                <div className="d-flex flex-column flex-md-row gap-3">
                                    {viewMode === "grid" && (
                                    <Form.Check
                                        ref={selectAllRef}
                                        type="checkbox"
                                        checked={
                                        selectedStudents.size > 0 &&
                                        selectedStudents.size ===
                                            students.filter(
                                            (s) => s.status !== "hired" && s.status !== "accept" 
                                            && s.status !== "offer_accept" && s.status !== "offer_declined"
                                            ).length
                                        }
                                        onChange={selectAllStudents}
                                        label={`Select All (${selectedStudents.size} selected)`}
                                        className="d-flex align-items-center"
                                    />
                                    )}

                                    {selectedStudents?.size !== 0 && (
                                    <div className="d-flex flex-wrap gap-2">
                                        <Button size="sm" variant="outline-warning" onClick={() => bulkUpdateStatus("pending")}>Pending All</Button>
                                        <Button size="sm" variant="outline-success" onClick={() => bulkUpdateStatus("accept")}>Shortlist All</Button>
                                        <Button size="sm" variant="outline-primary" onClick={() => bulkUpdateStatus("hired")}> Hire All</Button>
                                        <Button size="sm" variant="outline-danger" onClick={() => bulkUpdateStatus("rejected")}>Reject All</Button>
                                        <Button size="sm" variant="outline-danger" onClick={() => bulkUpdateStatus("cancelled")} > Cancelled All</Button>
                                    </div>
                                    )}
                                </div>
                            )}
                            <div className="d-flex d-lg-none justify-content-end align-items-center mb-1">
                                <Button
                                    variant="outline-primary"
                                    data-bs-toggle="offcanvas"
                                    size="sm"
                                    data-bs-target="#jobFilterCanvas"
                                >
                                    <Funnel size={16}/>
                                </Button>
                            </div>


                            {!isMobile && <div className="d-flex align-items-center gap-3">
                                <ButtonGroup>
                                    <Button
                                    variant={viewMode === "grid" ? "primary" : "outline-primary"}
                                    size="sm"
                                    onClick={() => setViewMode("grid")}
                                    >
                                    <Grid3X3 size={16} className="me-1" />
                                    Grid
                                    </Button>
                                    <Button
                                    variant={viewMode === "list" ? "primary" : "outline-primary"}
                                    size="sm"
                                    onClick={() => setViewMode("list")}
                                    >
                                    <List size={16} className="me-1" />
                                    List
                                    </Button>
                                </ButtonGroup>
                            </div>}
                        </div>
                        {students?.length === 0 ?
                        <div className="row">
                            <div className="col-12">
                                <div className="text-center py-5 bg-light rounded-2">
                                    <h4 className="text-muted">No applications found</h4>
                                    <p className="text-muted">Try adjusting your filters to see more results.</p>
                                </div>
                            </div>
                        </div>
                        :
                        <>
                            {viewMode === "grid" ?(
                            <div className="row">
                                {students.map(student => {
                                    return(
                                        <StudentApplicationGrid  
                                            key={student.id}
                                            student={student}
                                            selectedStudents={selectedStudents}
                                            toggleStudentSelection={toggleStudentSelection}
                                            statusButtons={statusButtons}
                                            confirmStatusChange={confirmStatusChange}
                                            DisabledMessage={DisabledMessage}
                                            isDisabled={isDisabled}
                                            openHistoryModal={openHistoryModal}
                                            confirmStatusToHired={confirmStatusToHired}
                                        />
                                    )
                                })}
                            </div>
                            ):
                            <div className="card shadow-sm border-0">
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead className="table-light">
                                            <tr>
                                            <th scope="col">
                                                <Form.Check
                                                    type="checkbox"
                                                    onChange={selectAllStudents}
                                                    checked={
                                                        selectedStudents.size > 0 &&
                                                        selectedStudents.size === students.filter(
                                                        (s) => s.status !== "hired" && s.status !== "accept"
                                                        ).length
                                                    }
                                                />
                                            </th>
                                            <th scope="col">Candidate</th>
                                            <th scope="col">Job Title</th>
                                            <th scope="col">Contact</th>
                                            <th scope="col">Education</th>
                                            <th scope="col">Skills</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {students.map((student) => {
                                                return(
                                                    <StudentApplicationTable 
                                                        key={student.id}
                                                        student={student}
                                                        selectedStudents={selectedStudents}
                                                        toggleStudentSelection={toggleStudentSelection}
                                                        DisabledMessage={DisabledMessage}
                                                        isDisabled={isDisabled}
                                                        confirmStatusChange={confirmStatusChange}
                                                        openHistoryModal={openHistoryModal}
                                                        getStatusBadgeVariant={getStatusBadgeVariant}
                                                        confirmStatusToHired={confirmStatusToHired}
                                                    />
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            }
                        </>}
                    </>
                }
            </main>
            :
            <>
                <Card className="mb-4 d-none d-lg-block">
                    <Card.Body>
                        <Row>
                            <Col md={3} className="mb-3">
                                <Form.Label className=" fw-bold  small mb-1">Search by Job Title</Form.Label>
                                <input
                                    type="text"
                                    placeholder="e.g: Frontend devloper"
                                    className="form-control w-100"
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                            </Col>
                            <Col md={3} className="mb-3">
                                <Form.Label className=" fw-bold  small mb-1">Filter by Status</Form.Label>
                                <select
                                    className="form-select w-100"
                                    value={filters.offer_letter_acceptance}
                                    onChange={handleFilterChange}
                                >
                                    <option value="">All Status</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Accepted">Accepted</option>
                                    <option value="Declined">Declined</option>
                                </select>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                {loading ? 
                <div className="py-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    </div>
                </div>
                :
                <main className="card shadow-sm border">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                        <thead className="text-dark">
                            <tr>
                                <th>Candidate</th>
                                <th>Job Title</th>
                                <th style={headerTbl}>Offer Accepted</th>
                                <th style={headerTbl}>Offer Date</th>
                                <th style={headerTbl}>Joining Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {placements.length === 0 && (
                            <tr>
                                <td colSpan="7" className="text-center">
                                No data available
                                </td>
                            </tr>
                            )}

                            {placements.map((item) => (
                            <tr key={item?.id}>
                                <td style={headerTbl}>{item?.first_name} {item?.last_name}</td>
                                <td style={headerTbl}>{item?.role || "-"}</td>
                                <td>
                                {item?.offer_letter_acceptance === "Accepted" ? (
                                    <Badge bg="success">Accepted</Badge>
                                ) : item?.offer_letter_acceptance === "Declined" ? (
                                    <Badge bg="danger">Declined</Badge>
                                ) : (
                                    <Badge bg="secondary">Pending</Badge>
                                )}
                                </td>

                                <td>{item?.offer_date || "-"}</td>
                                <td>{item?.joining_date || "-"}</td>

                                <td style={headerTbl}>
                                {item?.offer_letter ?  <a target="_blank" href={item?.offer_letter} className="btn btn-sm btn-success">View Offer</a>:null}
                                </td>
                            </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    {pagination && (pagination.current_page != pagination.last_page )   && (
                        <div className="d-flex justify-content-end m-2">
                        <PaginationControls
                            pagination={pagination}
                            onPageChange={(page) => fetchPlacements(page)}
                        />
                        </div>
                    )}
                </main>}
            </>
            }

            <Modal show={!!showHistoryModal} onHide={() => setShowHistoryModal(null)} centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Application Timeline</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <ApplicationTimelinePopup
                        application={showHistoryModal}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowHistoryModal(null)}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showInterviewModal} onHide={() => setShowInterviewModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Schedule Interview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                        <Form.Label>Interview Date</Form.Label>
                        <div>
                            <DatePicker
                                className="form-control"
                                style={{width:"100%"}}
                                selected={interviewData.date}
                                onChange={(date) =>
                                    setInterviewData((prev) => ({ ...prev, date }))
                                }
                                showYearDropdown
                                dateFormat="dd/MM/yyyy"
                                wrapperClassName="w-100"
                                placeholderText="Select interview date"
                            />
                        </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Interview Time</Form.Label>
                            <Form.Control
                                type="time"
                                className="custom-time-input"
                                value={interviewData.time}
                                onChange={(e) =>
                                setInterviewData((prev) => ({ ...prev, time: e.target.value }))
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                        <Form.Label>Message to Student</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Enter message for the student..."
                            value={interviewData.message}
                            onChange={(e) => setInterviewData((prev) => ({ ...prev, message: e.target.value }))}
                        />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowInterviewModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={scheduleInterview} disabled={!interviewData.date || !interviewData.time}>
                        Schedule & Send Email
                    </Button>
                </Modal.Footer>
            </Modal>

            <StatusChangeModal
                show={showModal}
                onHide={() => setShowModal(false)}
                studentId={modalStudentId}
                newStatus={modalStatus}
                onConfirm={handleConfirm}
                isHired={showHireModal}
                hiredModalDetails={hiredModalDetails}
                fetchPlacements={fetchStudentsApplication}
                setIsNowAndLater={setIsNowAndLater}
                isNowAndLater={isNowAndLater}
            />

            <style>
                {`
                input[type="time"].form-control {
                   
                    color: #333;
                    font-weight: 500;
                    border-radius: 0.5rem;
                    padding: 0.375rem 0.75rem;
                }
                input[type="time"]::-webkit-calendar-picker-indicator {
                    filter: invert(100%);
                    cursor: pointer;
                }
                .form-check-label{
                    margin-top:8px;
                }
                .react-datepicker-wrapper,
                    .react-datepicker__input-container {
                    display: block;
                    width: 100%;    
                }

                .schoolaname{
                    display: -webkit-box;
                    max-width: 200px;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                `}
            </style>
        </>
    )
}